export const getBackGroundPlugin = (background = 'white') => ({
    id: 'custom_canvas_background_color',
    beforeDraw: (chart) => {
        const ctx = chart.canvas.getContext('2d');
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle =
            background === 'black' ? '#000000' : background === 'dark' ? '#004673' : '#ffffff';
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
    },
    plugins: null,
});
export const pieWhiteBackgroundColors = ['#376eb4', '#6f8cc3', '#9cacd2', '#c6cee1', '#e6e6e6'];
export const pieWhiteBackgroundColorsExtended = [
    '#004673',
    '#0a5a96',
    '#b4cdf0',
    '#377b78',
    '#4ba5a0',
    '#96c8c3',
    '#e6e6e6',
];
export const pieDarkBackgroundColors = ['#ffffff', '#ccd7df', '#99b0c0', '#6689a0', '#336281'];
export const pieDarkBackgroundColorsExtended = [
    '#ffffff',
    '#ccd7df',
    '#99b0c0',
    '#377b78',
    '#4ba5a0',
    '#96c8c3',
    '#e6e6e6',
];
export const getDataSets = ({ darkBackground = false, data }) => {
    if (darkBackground) {
        if (data.datasets[0].data.length > 5) {
            return pieDarkBackgroundColorsExtended;
        }
        return pieDarkBackgroundColors;
    }
    if (data.datasets[0].data.length > 5) {
        return pieWhiteBackgroundColorsExtended;
    }
    return pieWhiteBackgroundColors;
};
export function getColor(index, colors) {
    return colors[index % colors.length];
}
